/**
 * The billing-banner COPY, shared by Layout.tsx's chrome banner and the
 * Start view's Konto card (task-8-brief.md: "the trial/past_due line from
 * billingBanner" -- Start restates the SAME line the shell already shows,
 * on the card that actually explains what it means, rather than inventing a
 * second version of it: "billing state is on the first screen, not buried
 * in a settings tab").
 *
 * MOVED HERE FROM Layout.tsx (Task 8 deviation, see task-8-report.md): the
 * mapping used to be a local, unexported function there. Two independent
 * copies of the same exhaustive BannerKind switch is exactly how the
 * `unknown` case (capabilities.ts review m-1) would have drifted a second
 * time -- one call site, one switch, both views read the same answer.
 * Layout.tsx's own rendering (banner position, `role="status"`) is
 * unchanged; only the copy lookup moved.
 */
import type { billingBanner } from './capabilities';
import { t } from './i18n';

export function billingBannerText(banner: ReturnType<typeof billingBanner>): string | null {
  switch (banner.kind) {
    case 'none': return null;
    // The gate pauses eBay for an unrecognised status; this is the sentence
    // that stops that being a mystery (capabilities.ts, m-1).
    case 'unknown': return t('billing.unknown');
    case 'past_due': return t('billing.past_due');
    case 'locked': return t('billing.locked');
    case 'canceled': return t('billing.canceled');
    case 'trial':
      if (banner.daysLeft === null) return t('billing.trialNoEnd');
      if (banner.daysLeft === 0) return t('billing.trialToday');
      if (banner.daysLeft === 1) return t('billing.trialOneDay');
      return t('billing.trial', { days: banner.daysLeft });
  }
}
